import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { ADMIN_ROLES } from '@/shared/config/access-roles';
import { APP_ROUTES } from '@/shared/config/routes-config';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const HomeContainer = React.lazy(() => import('../../containers/home/home.container'));

export const DashboardRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: <Navigate to={(APP_ROUTES.DASHBOARD_MODULE.CHILDREN as RouteConfig).HOME.FULL_PATH} />
  },
  {
    path: (APP_ROUTES.DASHBOARD_MODULE.CHILDREN as RouteConfig).HOME.FULL_PATH,
    element: (
      // <React.Suspense fallback={<div>Loading...</div>}>
      <DefaultLayout
        authenticationRequired={true}
        permittedList={ADMIN_ROLES}
        component={HomeContainer}
      />
      // </React.Suspense>
    )
  }
];
